import Vue from 'vue'
import App from './App.vue'
import store from './store'
import { createTeraSync } from '@iebh/vuex-tera-json';

// Bootstrap Vue
import './theme.scss'

// Import $tera / @iebh/Tera-fy global service
// NOTE: See bottom of file inside main async() init loop for when TeraFy actually boots
import TeraFy from "@iebh/tera-fy/dist/terafy.es2019.js"; // FIX: Use annoyingly old and specific version as Babel struggles with ESNEXT class imports
import TerafyVue from "@iebh/tera-fy/dist/plugin.vue2.es2019.js";

let terafy = new TeraFy()
	.set("devMode", process.env.VUE_APP_TERAFY_DEV)
	.setIfDev("verbosity", process.env.VUE_APP_TERAFY_VERBOSITY)
	.use(TerafyVue); // Add the Vue plugin

Vue.config.productionTip = false;

// --- TERA Sync Plugin Initialization ---
const teraSyncApi = createTeraSync({
	keyPrefix: 'wordFreq',
	isSeparateStateForEachUser: false,
	// autoSaveIntervalMinutes: 15 // Defaults to 15
}, store);

// Make the API accessible globally
Vue.prototype.$teraSync = teraSyncApi;
// --- End TERA Sync Plugin Initialization ---

(async ()=> {
	const app = window.app = new Vue({
		render: h => h(App),
		store,
		beforeDestroy() {
			// Cleanup
			if (teraSyncApi && typeof teraSyncApi.destroy === 'function') {
				console.log("Destroying TERA Sync Plugin");
				teraSyncApi.destroy();
			}
		}
	});

	// --- Set the Vue instance for the teraSyncApi ---
	if (teraSyncApi && typeof teraSyncApi.setVueInstance === 'function') {
		teraSyncApi.setVueInstance(app);
	} else {
		console.error("Failed to set Vue instance on TERA Sync API object.");
	}

	try {
		await terafy.init({
			app,
			Vue,
		});

		// --- Set TERA ready ---
		if (teraSyncApi && typeof teraSyncApi.setTeraReady === 'function') {
			console.log("Setting TERA Ready on Sync Plugin");
			await teraSyncApi.setTeraReady();
		} else {
			console.error("Failed to set TERA Ready on TERA Sync API object.");
		}
	} catch (error) {
		console.error("TeraFy initialization failed:", error);
	}

	app.$mount("#app");
})()